export const preferredTimeOptions = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
].map((item) => ({
    value: item,
    label: item,
}));
export var FormType;
(function (FormType) {
    FormType["LEAD_FORM"] = "leadForm";
    FormType["MAINTENANCE_FORM"] = "maintenanceForm";
})(FormType || (FormType = {}));
export const FORM_PERSONAL_DATA_MAX_LENGTH = {
    firstName: 40,
    lastName: 80,
    email: 60,
    phoneNumber: 15,
};
export const LEAD_FORM_ADDRESS_DATA_MAX_LENGTH = {
    address: 60,
    city: 40,
    postalCode: 20,
};
export const MAINTENANCE_FORM_FIELD_MAX_LENGTH = {
    myVehicle: 100,
    modelName: 40,
    vehicleLicensePlate: 80,
    vehicleKM: 20,
};
export const DISABLED_DAYS_FROM_TODAY = 7;
export const GENERIC_NOTES = 'genericNotes';
export const allowedDuplicateFields = [GENERIC_NOTES];
